import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Eye = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        id="Eye "
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.83325 8.00016C1.83325 7.84634 1.94569 7.50489 2.27054 7.02745C2.57948 6.5734 3.03552 6.06256 3.60705 5.58353C4.7553 4.62113 6.31217 3.8335 7.99992 3.8335C9.68766 3.8335 11.2445 4.62113 12.3928 5.58353C12.9643 6.06256 13.4204 6.5734 13.7293 7.02745C14.0542 7.50489 14.1666 7.84634 14.1666 8.00016C14.1666 8.15399 14.0542 8.49543 13.7293 8.97287C13.4204 9.42693 12.9643 9.93777 12.3928 10.4168C11.2445 11.3792 9.68766 12.1668 7.99992 12.1668C6.31217 12.1668 4.7553 11.3792 3.60705 10.4168C3.03552 9.93777 2.57948 9.42693 2.27054 8.97287C1.94569 8.49543 1.83325 8.15399 1.83325 8.00016ZM7.99992 2.8335C6.00577 2.8335 4.2293 3.7572 2.96469 4.81713C2.32979 5.34927 1.80953 5.92735 1.44377 6.46492C1.09391 6.9791 0.833252 7.53199 0.833252 8.00016C0.833252 8.46834 1.09391 9.02122 1.44377 9.53541C1.80953 10.073 2.32979 10.6511 2.96469 11.1832C4.2293 12.2431 6.00577 13.1668 7.99992 13.1668C9.99407 13.1668 11.7705 12.2431 13.0351 11.1832C13.67 10.6511 14.1903 10.073 14.5561 9.53541C14.9059 9.02122 15.1666 8.46834 15.1666 8.00016C15.1666 7.53199 14.9059 6.9791 14.5561 6.46492C14.1903 5.92735 13.67 5.34927 13.0351 4.81713C11.7705 3.7572 9.99407 2.8335 7.99992 2.8335ZM6.49992 8.00016C6.49992 7.17174 7.17149 6.50016 7.99992 6.50016C8.82835 6.50016 9.49992 7.17174 9.49992 8.00016C9.49992 8.82859 8.82835 9.50016 7.99992 9.50016C7.17149 9.50016 6.49992 8.82859 6.49992 8.00016ZM7.99992 5.50016C6.61921 5.50016 5.49992 6.61945 5.49992 8.00016C5.49992 9.38087 6.61921 10.5002 7.99992 10.5002C9.38063 10.5002 10.4999 9.38087 10.4999 8.00016C10.4999 6.61945 9.38063 5.50016 7.99992 5.50016Z"
        fill={color}
      />
    </svg>
  )
})

export default Eye
